export const authContextRef = { current: null }
